import App from 'app'
import { useEffect, useState } from 'react'
import { GetProduct, UpdateProductStock } from 'services/Product'
import { GetUser } from 'services/Session'
import { GetSetting } from 'services/Setting'
import NumberFormat from 'react-number-format';

export function StockOpname () {
	const user = GetUser()
	const [setting, setSetting] = useState({})
	const [loading, setLoading] = useState(false)
	const [items, setItems] = useState([])
	const [page, setPage] = useState(1)
	const [errorMessage, setErrorMessage] = useState('')
	const [searchTerm, setSearchTerm] = useState('')

	const getData = async (currentPage) => {
		await GetSetting(setSetting)
		if (currentPage) {
			setLoading(true)
			try {
				const res = await GetProduct({
					type: 'ready_stock',
					sorts: 'catalog.name,color.id,size.id',
					page: currentPage,
					per_page: 50,
				})
				if (res?.data?.results?.length > 0) {
					setItems(prevItems => [...prevItems, ...res?.data?.results])
					if (currentPage < res?.data?.page_context?.total_pages) {
						setPage(prevPage => prevPage + 1)
					}
				}
			} catch (error) {
				setErrorMessage(error?.response?.data?.error?.message?? 'Gagal terhubung ke server, silakan coba lagi nanti.')
				setTimeout(() => {
					setErrorMessage('')
				}, 3000)
			} finally {
				setLoading(false)
			}
		}
	}

	// Mengambil data saat komponen pertama kali di-mount dan saat page berubah
	useEffect(() => {
		getData(page)
	}, [page])

	// Fungsi untuk menghandle perubahan stok fisik
	const handlePhysicalQtyChange = (id, value) => {
		const updatedItems = items.map(item => {
			if (item.id === id) {
				const physicalQty = parseInt(value, 10) || 0
				return { ...item, physicalQty }
			}
			return item
		})
		setItems(updatedItems)
	}

	// Fungsi untuk menghitung selisih stok
	const calculateDifference = (systemQty, physicalQty) => {
		return physicalQty !== undefined && physicalQty !== null ? physicalQty - systemQty : '-'
	}

	// Fungsi untuk reset semua stok fisik ke 0
	const resetToZero = () => {
		const updatedItems = items.map(item => ({ ...item, physicalQty: 0 }))
		setItems(updatedItems)
	}

	// Fungsi untuk reset semua stok fisik ke stok sistem
	const resetToSystemQty = () => {
		const updatedItems = items.map(item => ({ ...item, physicalQty: item?.quantity?.available }))
		setItems(updatedItems)
	}

	const handleSubmit = async (e) => {
		setLoading(true)
		e.preventDefault()
		try {
			const modifiedItems = items
				.filter(item => item.physicalQty !== null && item.physicalQty !== undefined)
				.map((item) => ({ 
					code: item?.code, 
					quantity: item?.physicalQty,
				}))
			const res = await UpdateProductStock(modifiedItems)
			alert(res?.data?.message?? 'Stok produk berhasil diperbarui.')
		} catch (e) {
			setErrorMessage(e?.response?.data?.error?.message?? 'Gagal terhubung ke server, silakan coba lagi nanti.')
			setTimeout(() => {
				setErrorMessage('')
			}, 3000)
		} finally {
			setLoading(false)
		}
	}

	return (
		<App user={user} setting={setting}>
			<div className='px-4 pb-4'>
				{errorMessage && (
					<div className="fixed top-4 left-1/2 transform -translate-x-1/2 bg-red-500 text-white px-6 py-3 rounded-md shadow-md flex items-center" style={{zIndex: 9999}}>
						<span>{errorMessage}</span>
						<button className="ml-4 text-white focus:outline-none" onClick={() => setErrorMessage('')}>✖</button>
					</div>
				)}
				<div className="mx-auto mt-10 p-4 bg-white rounded-lg shadow-md w-full md:w-3/4">
					<h3 className="font-bold leading-tight tracking-tight text-center mb-4">
						Stok Opname
					</h3>
					<div className="flex justify-between items-center">
						<div className="space-x-4">
							<input
								type="text"
								placeholder="Cari..."
								className="border border-gray-300 rounded-md px-4 py-2.5"
								value={searchTerm}
								onChange={(e) => setSearchTerm(e.target.value)}
							/>
						</div>
						<div className="space-x-4">
							<button className="px-4 py-2.5 text-gray-800 bg-gray-200 rounded-md hover:bg-gray-400" onClick={resetToSystemQty}>Reset =</button>
							<button className="px-4 py-2.5 text-gray-800 bg-gray-200 rounded-md hover:bg-gray-400" onClick={resetToZero}>Reset 0</button>
							<button onClick={handleSubmit} type="submit" className="text-white bg-sky-500 hover:bg-sky-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-md px-4 py-2.5 text-center dark:bg-sky-500 dark:hover:bg-sky-700 dark:focus:ring-blue-800">
								{loading ? (
									<svg className="w-4 h-4 text-white animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
										<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
										<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
									</svg>
								) : (
									"Simpan"
								)}
							</button>
						</div>
					</div>
					{items.length > 0 && (
						<form className="space-y-4 md:space-y-6 pt-2" action="#">
							<div className="overflow-auto max-h-[500px]">
								<table className="table-auto w-full bg-white shadow-md rounded-lg">
									<thead className="sticky top-0 z-10 bg-white">
										<tr>
											<th className="px-2 py-2">Produk</th>
											<th className="px-2 py-2 text-right">Harga Satuan</th>
											<th className="px-2 py-2 text-right">Stok Pada Sistem</th>
											<th className="px-2 py-2 text-right">Stok Secara Fisik</th>
											<th className="px-4 py-2 text-right">Selisih</th>
										</tr>
									</thead>
									<tbody>
											{items.filter(item => item?.name?.toLowerCase().includes(searchTerm.toLowerCase())).map((item, index) => (
												<tr key={item.id + '-' + index} className="border-t">
													<td className="px-2 py-2">
														<div className="flex items-center space-x-4">
															<img src={item?.image?.url} alt={item.name} className="w-12 h-12 object-cover" />
															<span>{item?.name}</span>
														</div>
													</td>
													<td className="px-2 py-2 text-right"><NumberFormat value={item?.unit_price} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></td>
													<td className="px-2 py-2 text-right">{item?.quantity?.available}</td>
													<td className="px-2 py-2 text-right">
														<input
															type="number"
															className="border border-gray-300 rounded px-2 py-1 w-full text-right"
															value={item.physicalQty}
															onChange={(e) => handlePhysicalQtyChange(item.id, e.target.value)}
														/>
													</td>
													<td className="px-4 py-2 text-right">
														{calculateDifference(item?.quantity?.available, item.physicalQty)}
													</td>
												</tr>
											))}
									</tbody>
								</table>
							</div>
						</form>
					)}
				</div>
			</div>
		</App>
	)
}